import { dependency } from '../../utils/request';
import { frame, newElement } from '../../utils/drawing';
/**
 * @module directives/media/swiper
 */

let cssAdded = false;
const swiperDirectory = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/7.4.1/';
export default function swiperDirective(element = null, callback = null) {

  // Add style elements to head
  if (!cssAdded) {
    cssAdded = true;
    document.head.appendChild(newElement('link', {
      type: 'text/css',
      rel: 'stylesheet',
      href: `${swiperDirectory}swiper-bundle.min.css`
    }));
  }

  // Load in swiper lib

  let test = () => {
    return window.Swiper !== null && window.Swiper !== undefined;
  }
  dependency(swiperDirectory + 'swiper-bundle.min.js', test).then(() => {
    
    // Declare ready and callback
    if (element) frame(() => element.classList.add('swiper-ready'));
    if (callback) callback(window.Swiper);
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/swiper.js